import React from 'react';
import { Text } from '@soluto-design/react';

import BlockListItem, {
    BlockListItemProps,
} from '../../molecules/BlockListItem';
import cls from '@soluto-design/styles/cls';

export interface BlockListSmallProps {
    title?: string;
    items?: BlockListItemProps[];
    className?: string;
}

export default function BlockListSmall({
    title,
    items = [],
    className,
}: BlockListSmallProps) {
    return (
        <div className={cls(className)}>
            {title && (
                <Text
                    component="h3"
                    className="text-h400 text-text-primary pb-8">
                    {title}
                </Text>
            )}
            {items && items.length > 0 && (
                <ul>
                    {items.map((item, index) => (
                        <li
                            key={`blocklist-small-${index}`}
                            className="list-none border-t-small border-stroke-secondary">
                            <BlockListItem {...item} />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
